'use strict';
class Calculator {
    constructor() {
        this.coPerSquareMeter = [52.605, 68, 25.0803];
        this.resultingConcreteArray = [17000, 15000, 10000];
        this.assumptionOfFloorThicknessArray = [0.17, 0.15, 0.1];
        this.resultArray = [82, 26667, 13017, 80, 13017, 13017, 50, 7684, 0];
        this.resultTotalValue = 0;
        this.inputValue = 100000;
        this.activeTab = 1;
        this.calculateForm = document.querySelector('#calculate-form');
        if (!this.calculateForm)
            return;
        this.inputSquareMeters = this.calculateForm.querySelector('input[name="square-meters"]');
        this.rangeSquareMeters = this.calculateForm.querySelector('input[type="range"]');
        this.resultColumns = document.querySelectorAll('[data-calculate]');
        this.resultTotal = document.querySelector('[data-calculate-block-result]');
        this.radioButtons = document.querySelectorAll('.radio-calculator-buttons button');
        this.radioTabs = document.querySelectorAll('.radio-calculator-tab');
        this.addEventListeners();
        this.calculate();
    }
    calculate() {
        const self = this;
        self.resultingConcreteArray.forEach((value, index) => {
            self.resultingConcreteArray[index] = self.assumptionOfFloorThicknessArray[index] * self.inputValue;
        });
        const inputSqrt = Math.sqrt(self.inputValue);
        const coPerIndex = this.activeTab;
        self.resultTotalValue = (self.coPerSquareMeter[coPerIndex] * self.inputValue) - (self.coPerSquareMeter[2] * self.inputValue);
        self.resultArray[0] = self.resultingConcreteArray[1] / 250 / 3 * 4;
        self.resultArray[3] = self.resultArray[0] + 2;
        self.resultArray[6] = self.resultingConcreteArray[2] / 250 / 4 * 5;
        self.resultArray[1] = (self.inputValue / 900 * 4 * 30) - inputSqrt;
        self.resultArray[4] = self.inputValue / 900 * 240;
        self.resultArray[7] = (self.inputValue / 2500 * 4 * 50) - inputSqrt;
        self.resultArray[5] = self.resultArray[4];
        self.resultArray[2] = self.resultArray[4];
        self.resultTotal.innerText = parseInt(self.resultTotalValue.toString()).toLocaleString('fi-FI');
        self.resultColumns.forEach((column, index) => {
            column.innerText = parseInt(Math.round(self.resultArray[index]).toString()).toString();
        });
    }
    submitValue() {
        // Find email if exists
        let email = document.querySelector('input[name="email"]');
        const emailValue = email ? email.value : '';
        const formData = new FormData(this.calculateForm);
        formData.append('square-meters', this.inputValue.toString());
        formData.append('email', emailValue);
        const options = {
            method: 'POST',
            contentType: 'application/x-www-form-urlencoded',
            body: formData
        };
        fetch('/wp-admin/admin-ajax.php?action=submit_calculate', options)
            .then(response => response.json())
            .then(data => {
        });
    }
    addEventListeners() {
        const self = this;
        let userInputTimeout = null;
        this.rangeSquareMeters.addEventListener('input', (e) => {
            this.inputValue = parseFloat(this.rangeSquareMeters.value);
            this.inputSquareMeters.value = this.rangeSquareMeters.value;
            this.calculate();
            if (userInputTimeout) {
                clearTimeout(userInputTimeout);
            }
            userInputTimeout = setTimeout(() => {
                this.submitValue();
            }, 500);
        });
        this.inputSquareMeters.addEventListener('change', (e) => {
            this.inputValue = parseFloat(this.inputSquareMeters.value);
            if (this.inputValue < 3000) {
                this.inputSquareMeters.value = '3000';
                this.inputValue = 3000;
            }
            this.rangeSquareMeters.value = this.inputValue.toString();
            this.calculate();
            this.submitValue();
        });
        this.radioButtons.forEach((button) => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                this.radioButtons.forEach((rButton) => {
                    rButton.classList.remove('is-active');
                });
                self.activeTab = parseInt(button.getAttribute('data-tab-id'));
                this.radioTabs.forEach((tab) => {
                    tab.classList.add('d-none');
                    if (parseInt(tab.getAttribute('data-col-tab')) === self.activeTab) {
                        tab.classList.remove('d-none');
                    }
                });
                button.classList.add('is-active');
                self.calculate();
                self.submitValue();
            });
        });
    }
}
const calculator = new Calculator();
